/* =========================================================
   Blog BETA feed interactions (server-rendered cards).
   The .li-card posts are rendered server-side from Shopify (main-blog.liquid).
   This script only handles DOM interactions over them: topic filter, search,
   the filters toggle, and the "See more" expand/collapse + overflow detection.
   No data fetching — content comes from Shopify; comments come from
   blog-comments.js; the timeline from blog-timeline.js.
   ========================================================= */
(function () {
  "use strict";
  var feed = document.querySelector("[data-blog-feed]");
  if (!feed) return;
  // .li-card = Updates feed cards; .art-card = Articles grid cards (same
  // search/tag-filter contract via data-search / data-tags).
  var cards = [].slice.call(feed.querySelectorAll(".li-card, .art-card"));
  var emptyEl = document.querySelector("[data-feed-empty]");
  var activeTag = "", query = "";

  function apply() {
    var shown = 0;
    cards.forEach(function (c) {
      var tags = c.getAttribute("data-tags") || "";
      var hay = c.getAttribute("data-search") || "";
      var ok = true;
      if (activeTag && tags.split(",").indexOf(activeTag) === -1) ok = false;
      if (ok && query && hay.indexOf(query) === -1) ok = false;
      c.hidden = !ok;
      if (ok) shown++;
    });
    if (emptyEl) emptyEl.hidden = shown > 0 || cards.length === 0;
  }

  document.addEventListener("input", function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute("data-feed-search")) {
      query = e.target.value.trim().toLowerCase();
      apply();
    }
  });

  document.addEventListener("click", function (e) {
    var chip = e.target.closest && e.target.closest(".up2-chip");
    if (chip) {
      document.querySelectorAll(".up2-chip").forEach(function (c) { c.classList.remove("is-active"); });
      chip.classList.add("is-active");
      activeTag = chip.getAttribute("data-filter-tag") || "";
      var ftb = document.querySelector("[data-filters-toggle]");
      if (ftb) ftb.classList.toggle("has-active", !!activeTag);
      apply();
      return;
    }
    var ft = e.target.closest && e.target.closest("[data-filters-toggle]");
    if (ft) {
      var panel = ft.closest(".up2-panel");
      var filters = panel && panel.querySelector("[data-filters]");
      if (filters) {
        var open = filters.hasAttribute("hidden");
        if (open) filters.removeAttribute("hidden"); else filters.setAttribute("hidden", "");
        ft.setAttribute("aria-expanded", open ? "true" : "false");
        ft.classList.toggle("is-open", open);
      }
      return;
    }
    var more = e.target.closest && e.target.closest(".li-more");
    if (more) {
      var content = more.closest(".li-content");
      var isOpen = content.classList.toggle("is-open");
      more.setAttribute("aria-expanded", isOpen ? "true" : "false");
      return;
    }
  });

  // "See more" only shows when content actually overflows. Re-check as media loads.
  function checkOverflow(content) {
    if (content.classList.contains("is-open")) return;
    var inner = content.querySelector(".li-content-inner");
    if (inner && inner.scrollHeight - inner.clientHeight > 4) content.classList.add("is-overflow");
  }
  cards.forEach(function (card) {
    var content = card.querySelector(".li-content");
    if (!content) return;
    checkOverflow(content);
    content.querySelectorAll("img, video, iframe").forEach(function (m) {
      if (m.tagName === "IMG" && m.complete) return;
      var re = function () { checkOverflow(content); };
      m.addEventListener("load", re);
      m.addEventListener("loadedmetadata", re);
      m.addEventListener("error", re);
    });
  });
  setTimeout(function () {
    cards.forEach(function (c) { var ct = c.querySelector(".li-content"); if (ct) checkOverflow(ct); });
  }, 600);
})();
